import { render, staticRenderFns } from "./Directionality.vue?vue&type=template&id=2616c054&"
import script from "./Directionality.vue?vue&type=script&lang=js&"
export * from "./Directionality.vue?vue&type=script&lang=js&"
import style0 from "./Directionality.vue?vue&type=style&index=0&id=2616c054&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports